<template>
    <b-container>
        <b-row>
            <b-col>
                <h1 class="mt-4">Tracks</h1>
            </b-col>
            <b-col align="end">
                <b-button v-b-modal.addTrackModal variant="default" class="mt-4">Add new track</b-button>
            </b-col>
        </b-row>
        <b-pagination class="mt-4" v-model="currentPage" :total-rows="tracks.length" :per-page="perPage" size="md" />
        <b-table :current-page="currentPage" :per-page="perPage" class="mt-4" bordered :items="tracks" :fields="fields" striped></b-table>
        <b-pagination v-model="currentPage" :total-rows="tracks.length" :per-page="perPage" size="md" />
        <b-modal title="Add Track" header-bg-variant="info" centered id="addTrackModal" @ok="doAddTrack" no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
            <div class="d-block" style="color: black">
                <h2>Add new track</h2>
                <b-form-input class="mt-3" v-model="artist" type="text" placeholder="Artist" />
                <b-form-input class="mt-3" v-model="track" type="text" placeholder="Track" />
                <b-form-input class="mt-3" v-model="genre" type="text" placeholder="Genre" />
            </div>
        </b-modal>
    </b-container>
</template>

<script>
    import { EventBus } from "../../EventBus";

    export default {
        name: "TracksView",
        data() {
          return {
              tracks: [],
              fields: ['artist', 'track', 'genre'],
              perPage: 50,
              currentPage: 1,
              artist: '',
              track: '',
              genre: ''
          }
        },
        mounted() {
            this.getAllTracks();
        },
        methods: {
            getAllTracks() {
                EventBus.$emit('loading-show');
                this.$axios.get('tracks').then(result => {
                    EventBus.$emit('loading-hide');
                    this.tracks = result.data;
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            },
            doAddTrack() {
                EventBus.$emit('loading-show');
                this.$axios.post('tracks', {artist: this.artist, track: this.track, genre: this.genre}).then(() => {
                    this.getAllTracks();
                    this.track = '';
                    this.artist = '';
                    this.genre = '';
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: 'Track added successfully', type: 'success'});
                }).catch(err => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: err.message, type: 'danger'});
                });
            }
        }
    }
</script>

<style scoped>

</style>
